import { BasicButton, DangerButton, Stack, Text, Modal } from "@certn/cascadia";
import {
  DialogHeader,
  DialogContent,
  DialogFooter,
  Dialog,
} from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
  approveDenyHeader: string;
  approveDenyBody: string;
  credentials: string[] | undefined;
}

export function WithdrawRequestedConfirmationModal({
  isOpen,
  onClose,
  onSave,
  approveDenyHeader,
  approveDenyBody,
  credentials,
}: Props) {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} testID="withdrawal-request-confirmation-modal">
      <Dialog>
        {({ close }) => (
          <>
            <DialogHeader onClose={onClose}>{approveDenyHeader}</DialogHeader>
            <DialogContent>
              <Stack gap="space-4">
                <Text style="global/body-primary">
                  {approveDenyBody}
                  <ul>
                    {credentials?.map((credential) => (
                      <li key={credential}>
                        <Text
                          className={styles.boldText}
                          style="global/body-primary"
                        >
                          {credential}
                        </Text>
                      </li>
                    ))}
                  </ul>
                </Text>
              </Stack>
            </DialogContent>
            <DialogFooter>
              <DangerButton onPress={onSave}>{approveDenyHeader}</DangerButton>
              <BasicButton onPress={onClose}>{t("Cancel")}</BasicButton>
            </DialogFooter>
          </>
        )}
      </Dialog>
    </Modal>
  );
}

const styles = {
  boldText: css({
    fontWeight: "var(--font-weight-bold)",
  }),
};
